<div class="beslutninger">
  @for (beslutning of beslutninger(); track beslutning.id) {
    <beslutning-listevisning-kompakt [beslutning]="beslutning"/>
  }
</div>
